import { render, staticRenderFns } from "./FormElementRating.vue?vue&type=template&id=0f9d2132"
import script from "./FormElementRating.vue?vue&type=script&lang=js"
export * from "./FormElementRating.vue?vue&type=script&lang=js"
import style0 from "./FormElementRating.vue?vue&type=style&index=0&id=0f9d2132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports